import type { ImageEntryType, RichTextEntryType } from 'tsconfig/types';
import { CmsImage } from 'common-ui';
import { CmsRichText } from '../../CmsRichText/CmsRichText';

interface Props {
  image: ImageEntryType | null;
  eyebrow: string | null;
  paragraph: RichTextEntryType | null;
  isMobileView: boolean;
}

export const MainMediaSection = ({ image, eyebrow, paragraph, isMobileView }: Props) => (
  <div className="mcs-main-media" data-testid="main-media-section">
    {image && <CmsImage fill={true} contentItem={image} />}
    {!isMobileView && (
      <div className="mcs-main-desc">
        {eyebrow && <span className="eyebrowRegular">{eyebrow}</span>}
        {paragraph && <CmsRichText contentItem={paragraph} />}
      </div>
    )}
  </div>
);
